import React from 'react'

/** @jsxImportSource @emotion/react */
import { css } from '@emotion/core';
import { gsColors } from '../../../../styles/Variables';

const style = css`
  border: 1px solid ${gsColors.black};
  font-family: Euclid;
  font-size: 16px;
  padding: 14px;
  width: 100%;

  ::placeholder {
    color: ${gsColors.meredithGrey};
  }

  &:focus {
    outline: 0;
  }
`;

export default function Textarea(props) {
  return <textarea css={style} {...props} />;
};
